import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { StoreContext } from "../context/StoreContext";
import { useLocation } from "react-router-dom";
import { isStoreHost } from "utils/platformHost";

const NotFound: React.FC = () => {
 const { t } = useTranslation();
 // Safely access store context - may be undefined if not within StoreProvider
 const storeContext = useContext(StoreContext);
 const store = storeContext?.store || null;
 const storeLoading = storeContext?.loading || false;
 const location = useLocation();

 // Check if we're on a store host (not platform domain)
 const onSubdomain = isStoreHost();

 // If we're on a subdomain and store doesn't exist (after loading), show store not found
 // This prevents showing "Page Not Found" when the store itself doesn't exist
 if (onSubdomain && !storeLoading && !store) {
  return (
   <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center p-8">
     <h1 className="text-2xl font-bold text-gray-900 mb-4">{t("notFound.storeNotFound")}</h1>
     <p className="text-gray-600 mb-4">
      {t("notFound.storeNotFoundMessage")}
     </p>
     <p className="text-sm text-gray-500">
      {t("notFound.storeNotFoundHelp")}
     </p>
    </div>
   </div>
  );
 }

 // Regular "Page Not Found" for valid stores or main domain
 return (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
   <div className="text-center p-8">
    <h1 className="text-3xl font-bold text-gray-900 mb-4">{t("notFound.title")}</h1>
    <p className="text-gray-600 mb-4">
     {t("notFound.message")}
    </p>
    <p className="text-sm text-gray-500">
     {t("notFound.pageAtPathNotFound", { path: location.pathname })}
    </p>
   </div>
  </div>
 );
};

export default NotFound;
